import React from "react";
import {WizTableForm} from '@/containers/common'

const program = WizTableForm.Config.program(this, {apiParams: {isPower: false}})
const organization = WizTableForm.Config.organization(this, {apiParams: {state: 1}})

//配置项
const componentName = "programReport";
//课程验证
const programIdListValidator = (rule, value, callback) => {
  if (value && value.length > 10) {
    wizNotice.warn('课程最多选择10个')
    callback('课程最多选择10个')
  }
  callback();
}
function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "课程名称",
      name: "programName",
      tableItem: {},
    },
    // {
    //   title: "课程名称",
    //   name: "programId",
    //   searchItem: {
    //     ...program,
    //     diy: WizTableForm,
    //     selectType: 'radio',
    //     rules: [
    //       {
    //         required: true,
    //         message: '请选择课程名称'
    //       }
    //     ]
    //   },
    // },
    {
      title: "课程名称",
      name: "programIdList",
      searchItem: {
        ...program,
        diy: WizTableForm,
        selectType: 'checkbox',
        rules: [
          {
            required: true,
            message: '请选择课程'
          },
          {
            validator: programIdListValidator
          }
        ]
      },
    },
    {
      title: "课程编码",
      name: "scoId",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "课程学习率",
      name: "rate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      }
    },
    {
      title: "应学习人数",
      name: "shoudCount",
      tableItem: {},
    },
    {
      title: "已学习人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "已通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    }
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        },
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListProgramOrg`,
    payload: {
      key: `${componentName}@getPageListProgramOrg`,
      apiParams: {pageNum: 1, pageSize: 10},
    },
  },
  export: {
    path: `${componentName}/exportProgramOrg`,
    payload: {
      key: `${componentName}@exportProgramOrg`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
